var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgServer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 13C10.4477 13 10 13.4477 10 14C10 14.5523 10.4477 15 11 15C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15C7.55228 15 8 14.5523 8 14C8 13.4477 7.55228 13 7 13ZM22 4C22 2.34315 20.6569 1 19 1H5C3.34315 1 2 2.34315 2 4V8C2.00441 8.74005 2.28221 9.45236 2.78 10C2.28221 10.5476 2.00441 11.2599 2 12V16C2 17.6569 3.34315 19 5 19H11V21H3C2.44772 21 2 21.4477 2 22C2 22.5523 2.44772 23 3 23H21C21.5523 23 22 22.5523 22 22C22 21.4477 21.5523 21 21 21H13V19H19C20.6569 19 22 17.6569 22 16V12C21.9956 11.2599 21.7178 10.5476 21.22 10C21.7178 9.45236 21.9956 8.74005 22 8V4ZM20 16C20 16.5523 19.5523 17 19 17H5C4.44772 17 4 16.5523 4 16V12C4 11.4477 4.44772 11 5 11H19C19.5523 11 20 11.4477 20 12V16ZM20 8C20 8.55228 19.5523 9 19 9H5C4.44772 9 4 8.55228 4 8V4C4 3.44772 4.44772 3 5 3H19C19.5523 3 20 3.44772 20 4V8ZM11 5C10.4477 5 10 5.44772 10 6C10 6.55228 10.4477 7 11 7C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5ZM7 5C6.44772 5 6 5.44772 6 6C6 6.55228 6.44772 7 7 7C7.55228 7 8 6.55228 8 6C8 5.44772 7.55228 5 7 5Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default ForwardRef;